import { QRCodeSVG } from "qrcode.react";
import React, { useState } from "react";
// import { Helmet } from "react-helmet";
import { ReactMultiEmail } from "react-multi-email";
import "react-multi-email/dist/style.css";
import { useNavigate } from "react-router-dom";
import { Navbar } from "../../components/index.js";
import DialogModal from "../../components/DialogModal/index.jsx";
import Header from "../../components/Referrals/children/Header";
import { useReferralsInvite } from "../../services/mutations.js";
import ToastMessage from "../../sharedcomponents/Toast.js";
import { ASSETS, TOAST_TYPE } from "../../utils/config.js";
import { getLoggedInUser } from "../../utils/helpers.js";
import "./styles.css";
import * as Styled from "./styles.js";
import { useSelector } from "react-redux";

function Invite() {
  const [emails, setEmails] = useState([]);
  const [focused, setFocused] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState("");

  const { userProfile } = useSelector((state) => state.userProfile);
  const userType = userProfile.referral_type;

  const nav = useNavigate();

  const handleToastCloseCallback = () => {
    setMessage("");
  };

  const urlToCopy =
    window.location.origin + "/otheruserprofile/" + getLoggedInUser()?.id;
  const onCopyLink = () => {
    navigator.clipboard.writeText(urlToCopy);
    setMessage("Copied!");
  };

  const { mutate, isLoading, isError, data } = useReferralsInvite();

  const onSendInvites = () => {
    mutate({ emails: emails });
    if (data) {
      setMessage("Sent Successfully!");
    }
  };

  const onPressUpgrade = () => {
    nav("/settings?option=subscriptions&from_referral=true");
  };

  const onStartEarning = () => {
    if (userType === "Default") setShowAlert(true);
    else nav("/referrals");
  };

  return (
    <>
      {/* <Helmet>
        <title>User Profile</title>
        <meta property="og:url" content={urlToCopy} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="User Profile" />
        <meta
          property="og:description"
          content="Check out this amazing user profile!"
        />
        <meta
          property="og:image"
          content={
            "https://iyuga-backend.s3.amazonaws.com/uploads/9cb11984-feca-4a49-b448-2b212c73caa3-TEXTS.svg"
          }
        />
      </Helmet> */}
      <Navbar />

      <Styled.Wrapper>
        <Header
          title="Join our Earnings Program"
          text="Receive 10% commission on all active subscription referrals for LIFE!"
          buttonText={"Start Earning"}
          onButtonPress={onStartEarning}
        />

        <Styled.InviteFriendsContainer>
          <Styled.ToRowDiv>
            <Styled.InviteIcon src={ASSETS.ReferInvite}></Styled.InviteIcon>
            <Styled.InviteFriendsTitle>
              Invite Friends
            </Styled.InviteFriendsTitle>
          </Styled.ToRowDiv>

          <Styled.InputContainer>
            <Styled.Label>Email</Styled.Label>
            <Styled.ToRowDiv>
              <ReactMultiEmail
                // placeholder="Input your email"
                emails={emails}
                onChange={(_emails) => {
                  setEmails(_emails);
                }}
                className="email-input-container"
                inputClassName="email-input"
                autoFocus={true}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                getLabel={(email, index, removeEmail) => {
                  return (
                    <div data-tag key={index} className="email-item">
                      <div data-tag-item className="email-text">
                        {email}
                      </div>
                      <span
                        className="email-cross"
                        data-tag-handle
                        onClick={() => removeEmail(index)}
                      >
                        ×
                      </span>
                    </div>
                  );
                }}
              />
              <Styled.ShareIcons
                src={ASSETS.Send}
                onClick={onSendInvites}
              ></Styled.ShareIcons>
            </Styled.ToRowDiv>
          </Styled.InputContainer>

          <Styled.InputContainer>
            <Styled.Label>Share your Gallery Link</Styled.Label>
            <Styled.ToRowDiv>
              <Styled.GalleryLink>
                <Styled.LinkText>
                  https://iyuga.com/invite/1ade284
                </Styled.LinkText>
              </Styled.GalleryLink>
              <Styled.ShareIcons
                src={ASSETS.ReferCopy}
                onClick={onCopyLink}
              ></Styled.ShareIcons>
            </Styled.ToRowDiv>
          </Styled.InputContainer>

          <Styled.QrContainer>
            {/* <Styled.Label>QR Code</Styled.Label> */}
            <div
              style={{
                backgroundColor: "#e9f1fa",
                padding: 40,
                alignSelf: "center",
                borderRadius: "100%",
              }}
            >
              <QRCodeSVG value={urlToCopy} />
            </div>
          </Styled.QrContainer>
        </Styled.InviteFriendsContainer>
      </Styled.Wrapper>
      {message && (
        <ToastMessage
          message={message || "Some thing went wrong. Please try again"}
          type={TOAST_TYPE.SUCCESS}
          show={true}
          handleCloseCallback={handleToastCloseCallback}
        />
      )}

      <DialogModal
        open={showAlert}
        onClose={() => setShowAlert(false)}
        title="Upgrade Subscription"
        message="All premium features will be added when you subscribe to premium plan."
        primaryButton={"Upgrade"}
        secondaryButton={"Cancel"}
        onPrimaryPress={onPressUpgrade}
        onSecondaryPress={() => setShowAlert(false)}
      />
    </>
  );
}

export default Invite;
